import { schedulesServices } from '../../database/schedules.database'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'
import {
    GetAllStoresResponse,
    GetSchedulesResponse,
} from './interfaces/schedule.interface'
import { RequestGetAddress } from './interfaces/schedule.interface/schedule.getaddress.interface'
import { ResponseGetFormsAdditionals } from './interfaces/schedule.interface/schedule.getformsadditionals.interface'
import { ResponseGetLocalizationData } from './interfaces/schedule.interface/schedule.getlocalizationdata.interface'
import { ResponseGetStore } from './interfaces/schedule.interface/schedule.getstore.interface'
import { ResponseGetWise } from './interfaces/schedule.interface/schedule.getwise.interface'
import { error as logError, debug as logDebug } from '../utils/logger'
interface PropsGetSchedulesAndGetAllStore {
    authToken: string
    version?: string | null
    version_schedules?: string | null
    page?: string
    size?: string
    type?: string
}
interface PropsGetSchedulesPos {
    authToken: string
    page: string | null
    size: string | null
    type?: string
}
interface PropsGetSchedulesAdvances {
    authToken: string
    page: string | null
    size: string | null
    date_modified: string | null
    retries?: number
}
export const request_get_schedules = async ({ authToken, version, retries = 0 }) => {
    const URL_GET_SCHEDULES = apiUrl + '/oneapp/get_schedules'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
        }
        const data = await sendRequest(
            URL_GET_SCHEDULES,
            'GET',
            headers,
            null,
            retries,
            10,
            null,
            [],
            false,
        )
        // const data = await sendRequest(URL_GET_SCHEDULES, 'GET', headers, null, retries, 10)
        return data
    } catch (error) {
        logError('ScheduleService', 'Error en request_get_schedules:', error)
        throw error
    }
}

export const request_get_all_store = async ({
    authToken,
    page,
    size,
    type,
    version,
}: PropsGetSchedulesAndGetAllStore) => {
    const URL_GET_ALL_STORE = apiUrl + '/oneapp/get_all_store'
    try {
        const headers = {
            Authorization: authToken,
            page: page,
            size: size,
            type: type,
            version: version,
        }
        const reintentos = 3
        const data = await sendRequest(
            URL_GET_ALL_STORE,
            'GET',
            headers,
            null,
            reintentos,
            120,
        )
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_all_store failed', error)
        throw error
    }
}
export const request_get_schedules_by_pos = async ({
    authToken,
    page,
    size,
    type,
}: PropsGetSchedulesPos) => {
    const URL = `${apiUrl}/oneapp/get_schedules_by_pos?page=${page}&limit_page=${size}`
    try {
        const headers = {
            Authorization: authToken,
            type: type,
        }
        const data = await sendRequest(URL, 'GET', headers, null, 3, 30)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_schedules_by_pos failed', error)
        throw error
    }
}
export const request_get_schedules_advances = async ({
    authToken,
    page,
    size,
    date_modified,
    retries = 0,
}: PropsGetSchedulesAdvances) => {
    let URL = `${apiUrl}/oneapp/get_schedules_advances?page=${page}&limit_page=${size}`
    if (date_modified != undefined) {
        URL = `${apiUrl}/oneapp/get_schedules_advances?page=${page}&limit_page=${size}&date_last_updated=${date_modified}`
    }
    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(
            URL,
            'GET',
            headers,
            null,
            retries,
            10,
            null,
            [],
            false,
        )
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_schedules_advances failed', error)
        throw error
    }
}

export const request_get_schedule_forms = async ({
    authToken,
}: PropsGetSchedulesAndGetAllStore) => {
    const URL_GET_ALL_FORMS = apiUrl + '/oneapp/get_forms_schedules'
    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(
            URL_GET_ALL_FORMS,
            'GET',
            headers,
            null,
            3,
            10,
        )
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_schedule_forms failed', error)
        throw error
    }
}

export const request_get_perfect_store = async ({
    authToken,
    version,
}: PropsGetSchedulesAndGetAllStore) => {
    const URL = apiUrl + '/oneapp/get_perfect_store_zip'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
        }
        const data = await sendRequest(URL, 'GET', headers, null, 0, 20)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_perfect_store failed', error)
        throw error
    }
}
interface PropsSaveForm {
    authToken: string
    body: {
        form: string
        id_checkin?: string
        process_now?: boolean
        date?: string
        schedule_id?: string
        checkin_id?: string
        dif_utc?: string
    }
}
export const request_save_form = async ({ authToken, body }: PropsSaveForm) => {
    const URL = apiUrl + '/oneapp/save_form'

    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(URL, 'POST', headers, body, 0, 10)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_save_form error', error)
    }
}

interface PropsCheckin {
    authToken: string
    body: {
        store_id?: string
        distributor_id?: string
        lat: string
        lng: string
        date_init: string
        dif_utc: string
        schedule_id: string
        objectives?: string[]
        steps_distributor?: any[]
    }
}
interface PropsCheckout {
    authToken: string
    body: {
        store_id?: string
        distributor_id?: string
        id_check_in: string
        lat: string
        lng: string
        date_finish: string
        dif_utc: string
        schedule_id: string
        steps_distributor?: any[]
    }
}
export const request_checkin = async ({ authToken, body }: PropsCheckin) => {
    const URL = apiUrl + '/user_check_in'

    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(URL, 'POST', headers, body, 0)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_checkin error', error)
    }
}
export const request_checkout = async ({ authToken, body }: PropsCheckout) => {
    const URL = apiUrl + '/user_check_out'

    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(URL, 'POST', headers, body, 0)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_checkout error', error)
    }
}
export const request_add_pos = async ({ authToken, body }) => {
    const URL_ADD_POS = apiUrl + '/oneapp/add_pos'

    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }

        const data = await sendRequest(URL_ADD_POS, 'POST', headers, body, 0, 15)

        if (data && data.status && data.status === 1) {
            return data.response
        } else {
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'request_add_pos error', error)
        return null
    }
}

interface PropsGetWise {
    authToken: string
}
export const request_get_wise = async ({ authToken }: PropsGetWise) => {
    const URL_GET_WISE = apiUrl + '/oneapp/get_wise'
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }

        const data = await sendRequest(
            URL_GET_WISE,
            'GET',
            headers,
            null,
            3,
            5,
            null,
            null,
            false,
        )

        if (data && data.status && data.status === 1) {
            return data.response as ResponseGetWise
        } else {
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'request_get_wise error', error)
    }
}

interface PropsGetStore {
    authToken: string
    store_id: string
    schedule_id: string
}
export const request_get_store = async ({
    authToken,
    store_id,
    schedule_id,
}: PropsGetStore) => {
    const URL = apiUrl + '/oneapp/get_store'
    try {
        const headers = {
            Authorization: authToken,
            store_id: store_id,
            schedule_id: schedule_id,
        }
        const data = await sendRequest(URL, 'GET', headers, null, 0, 20)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_store error', error)
    }
}

export const request_get_schedule_period = async ({ authToken }) => {
    const URL = `${apiUrl}/oneapp/get_schedule_period`
    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(
            URL,
            'GET',
            headers,
            null,
            0,
            5,
            null,
            [],
            false,
        )
        if (data.status && data.response && data.response.single) {
            return data.response.single
        } else {
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'request_get_schedule_period error', error)
        return null
    }
}

export const request_update_schedule_periods = async ({ authToken, body }) => {
    const URL = `${apiUrl}/oneapp/update_schedule_periods`
    try {
        logDebug('ScheduleService', 'apiUrl', apiUrl)
        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
            },
            body: JSON.stringify(body),
        })

        if (response.ok) {
            const data = await response.json()
            return data
        } else {
            logError(
                'ScheduleService',
                'Error al realizar la solicitud update_schedule_periods',
            )
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'update_schedule_periods error', error)
        return null
    }
}

//Moderator
export const request_get_periods_status = async ({ authToken }) => {
    const URL = `${apiUrl}/oneapp/get_periods_status`
    try {
        const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
            },
        })
        if (response.ok) {
            const data = await response.json()
            return data.single
        } else {
            logError(
                'ScheduleService',
                'Error al realizar la solicitud request_get_periods_status',
            )
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'request_get_periods_status error', error)
        return null
    }
}
export const request_get_period = async ({ authToken, id_period }) => {
    const URL = `${apiUrl}/oneapp/get_period`
    try {
        const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
                period_id: id_period,
            },
        })
        if (response.ok) {
            const data = await response.json()
            return data.single
        } else {
            logError('ScheduleService', 'Error al realizar la solicitud get_period')
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'get_period error', error)
        return null
    }
}
export const request_set_period_status = async ({ authToken, body }) => {
    const URL = `${apiUrl}/oneapp/set_period_status`
    try {
        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
            },
            body: JSON.stringify(body),
        })
        if (response.ok) {
            const data = await response.json()
            return data
        } else {
            logError(
                'ScheduleService',
                'Error al realizar la solicitud update_schedule_periods',
            )
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'set_period_status error', error)
        return null
    }
}

interface RequestSaveSchedulesActivitiesProps {
    authToken: string
    schedule_id?: string
    activities: string
    checkin_id?: string
}

export const request_save_schedules_activities = async ({
    authToken,
    schedule_id,
    activities,
    checkin_id,
}: RequestSaveSchedulesActivitiesProps) => {
    const URL = `${apiUrl}/oneapp/save_schedules_activities`
    try {
        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
                schedule_id: schedule_id,
                activities: activities,
                checkin_id: checkin_id ?? null,
            },
            // body: JSON.stringify(body),
        })
        if (response.ok) {
            const data = await response.json()
            return data
        } else {
            logError(
                'ScheduleService',
                'Error al realizar la solicitud update_schedule_periods',
            )
            return null
        }
    } catch (error) {
        logError('ScheduleService', 'save_schedules_activities error', error)
        return null
    }
}

export const request_get_forms_additionals = async (
    authToken: string,
    date_finish: string | null,
) => {
    const URL = `${apiUrl}/schedule/get_forms_additionals`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            date_finish: date_finish,
        }
        const data = await sendRequest(URL, 'GET', headers, null, 0, 7)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_forms_additionals failed', error)
        return null
    }
}

interface RequestGetUsersDropdownProps {
    authToken: string
    form_id: string | null
    schedule_id: string | null
    store_id: string | null
    question_id: string | null
}

export const request_get_users_dropdown = async ({
    authToken,
    form_id,
    schedule_id,
    store_id,
    question_id,
}: RequestGetUsersDropdownProps) => {
    const URL = `${apiUrl}/oneapp/get_users_dropdown`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            form_id,
            schedule_id,
            store_id,
            question_id,
        }
        const data = await sendRequest(URL, 'GET', headers, null, 0, 7)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_get_users_dropdown failed', error)
        return null
    }
}

interface RequestCreateOrganization {
    authToken: string
    body: {
        name_fantasy: string
        name_legal: string
        cuil: string
        fiscal_address: string
        fiscal_cp: string
        province: string
        city: string
        client_code: string
    }
}

export const request_create_organization = async ({
    authToken,
    body,
}: RequestCreateOrganization) => {
    const URL = `${apiUrl}/oneapp/create_organizations`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }

        const data = await sendRequest(URL, 'POST', headers, body, 0, 7)
        return data
    } catch (error) {
        logError('ScheduleService', 'request_create_organization failed', error)
        return null
    }
}

interface RequestGetLocalizationData {
    authToken: string
    country_id: string
}
export const request_get_localization_data = async ({
    authToken,
    country_id,
}: RequestGetLocalizationData): Promise<ResponseGetLocalizationData> => {
    const URL = `${apiUrl}/oneapp/localization_data`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            country_id: country_id,
        }

        const { response } = await sendRequest(URL, 'GET', headers, null, 0, 7)
        return response
    } catch (error) {
        logError('ScheduleService', 'request_get_localization_data failed', error)
        return null
    }
}

interface RequestCreatePos {
    authToken: string
    data: {
        store_name: string
        store_province: string
        store_city: string
        store_address: string
        store_fiscal_cp: string

        organization_id?: string
        organization_name: string
        organization_code: string
        organization_cuil: string
        organization_province: string
        organization_city: string
        organization_address: string
        organization_fiscal_cp: string
    }
}

export const request_create_pos = async ({ authToken, data }: RequestCreatePos) => {
    const URL = `${apiUrl}/oneapp/create_pos`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }
        const { response } = await sendRequest(URL, 'POST', headers, data, 0, 7)
        logDebug('ScheduleService', 'request_create_pos response', response)

        return response
    } catch (error) {
        logError('ScheduleService', 'request_create_pos failed', error)
        return null
    }
}

interface GetAddressProps {
    authToken: string
    lat: string
    lng: string
}
export const request_get_address = async ({
    authToken,
    lat,
    lng,
}: GetAddressProps): Promise<RequestGetAddress> => {
    const URL = `${apiUrl}/oneapp/get_address`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            lat,
            lng,
        }
        const { response } = await sendRequest(URL, 'GET', headers, null, 0, 7)

        return response
    } catch (error) {
        logError('ScheduleService', 'request_get_address failed', error)
        return null
    }
}

interface RequestSendFormsView {
    authToken: string
    data: {
        activity_id: string
        status: number
        date: string
        count: number
        form_name: string
        status_send: number
        schedule_id: string
    }
}
export const request_send_forms_view = async ({
    authToken,
    data,
}: RequestSendFormsView) => {
    const URL = `${apiUrl}/oneapp/send_forms_view`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }
        const response = await sendRequest(URL, 'POST', headers, data, 0, 7)
        return response
    } catch (error) {
        logError('ScheduleService', 'request_send_forms_view failed', error)
        return null
    }
}

interface ResponseGetFormsPending {
    status: number
    single: {
        startISO: string
        startMinusDaysISO: string
        formsPending: FormsPending[]
    }
}
export interface FormsPending {
    schedule_id: string
    checkin_id?: string
    forms: string[]
}

export const request_get_forms_pending = async (
    authToken: string,
): Promise<ResponseGetFormsPending> => {
    const URL = `${apiUrl}/oneapp/forms_pending`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
        }
        const { response } = await sendRequest(URL, 'GET', headers, null, 0)
        return response
    } catch (error) {
        logError('ScheduleService', 'request_get_forms_pending failed', error)
        return null
    }
}

export interface RequestGetIndicators {
    authToken: string
    schedule_id: string
    timestamp: string
}

export interface ResponseGetIndicators {
    status: number
    single: {
        indicators: Indicator[]
    }
}
export interface Indicator {
    kpis_indicators: {
        kpi: string
        value: number
        monthOverMonthPercentChange?: string
        monthOverMonthChangeFormatted?: string
        type: string
        index: number
        criticalMomentCode?: string
        scoreForm: string
        alerts?: string
        created_date?: string
        modified_date?: string
        tags?: { _id: number; name: string }[]
    }
    pos_id: string
}
export const request_get_indicators = async ({
    authToken,
    schedule_id,
    timestamp,
}: RequestGetIndicators): Promise<ResponseGetIndicators> => {
    const URL = `${apiUrl}/oneapp/get_indicators`
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            schedule_id: schedule_id,
            timestamp: timestamp || '',
        }
        const { response } = await sendRequest(URL, 'GET', headers, null, 0, 20)
        return response
    } catch (error) {
        logError('ScheduleService', 'request_get_indicators failed', error)
        return null
    }
}
